module.exports = __webpack_public_path__ + "img/121.found_similar.66f9392f.svg";